import { useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { api, errMsg, photoUrl } from "@/lib/api";
import { PhotoCropDialog } from "@/components/PhotoCropDialog";

const SIZES = { sm: "h-10 w-10 text-sm", md: "h-16 w-16 text-xl", lg: "h-24 w-24 text-3xl" };
const initials = (name = "") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export const Avatar = ({ photo, name, size = "sm", square = false, testid }) => (
  <div data-testid={testid} className={`${SIZES[size]} shrink-0 overflow-hidden border-2 border-primary/60 bg-[#1B1D21] ${square ? "rounded-xl" : "rounded-full"} flex items-center justify-center font-extrabold text-[#FEDC19]`}>
    {photo ? <img src={photoUrl(photo)} alt={name} className="h-full w-full object-cover" /> : initials(name)}
  </div>
);

export const AvatarEdit = ({ photo, name, endpoint, onSaved, size = "lg", square = false, testid }) => {
  const [busy, setBusy] = useState(false);
  const [file, setFile] = useState(null);
  const pick = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.type.startsWith("image/")) return toast.error("Please choose an image file");
    setFile(f);
  };
  const upload = async (f) => {
    setFile(null);
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/photos", fd);
      await api.put(endpoint, { path: data.path });
      toast.success("Photo updated");
      onSaved(data.path);
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <>
    <label className="group relative inline-block cursor-pointer" title="Change photo">
      <Avatar photo={photo} name={name} size={size} square={square} testid={testid} />
      <span className="absolute -bottom-1 -right-1 rounded-full bg-primary p-1.5 text-primary-foreground shadow transition-transform group-hover:scale-110">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Camera className="h-3.5 w-3.5" />}
      </span>
      <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </label>
    {file && <PhotoCropDialog file={file} round={!square} onCancel={() => setFile(null)} onDone={upload} />}
    </>
  );
};
